import { SlideLoveCover } from './SlideLoveCover'
import { SlideAttentionProblem } from './SlideAttentionProblem'
import { SlideWhatToSnakify } from './SlideWhatToSnakify'
import { SlideAlreadyAtBoehringer } from './SlideAlreadyAtBoehringer'
import { SlideSharedAdvantage } from './SlideSharedAdvantage'
import { SlideSnakToCampaign } from './SlideSnakToCampaign'
import { SlideChannelEntryPoints } from './SlideChannelEntryPoints'
import { SlideInternalCTA } from './SlideInternalCTA'

/** The internal Boehringer deck — exactly eight pages, presented in this order. */
export const slides = [
  SlideLoveCover,
  SlideAttentionProblem,
  SlideWhatToSnakify,
  SlideAlreadyAtBoehringer,
  SlideSharedAdvantage,
  SlideSnakToCampaign,
  SlideChannelEntryPoints,
  SlideInternalCTA,
]

export const slideTitles: { section: string; title: string }[] = [
  { section: '01', title: 'All You Need Is Love' },
  { section: '02', title: 'HCPs Don’t Lack Content. They Lack Time.' },
  { section: '03', title: 'You Probably Already Have Something We Can Snakify' },
  { section: '04', title: 'Boehringer Is Already Snakifying' },
  { section: '05', title: 'From Individual Snaks to Shared Advantage' },
  { section: '06', title: 'One Snak Can Become a Continuous Campaign' },
  { section: '07', title: 'One Experience. Many Entry Points.' },
  { section: '08', title: 'What Could We Snakify for Your Brand?' },
]
